export const Routes = {
    getQR: 'clients/getpassqr',
}